import { clsx } from "clsx";
import { ReactNode } from "react";

import { Button } from "../button";
import { Displayer } from "../editor";
import { Icon, IconName } from "../icon";

export type ModalHeaderProps = {
  icon?: IconName;
  iconBgColor?: string;
  hideIconOnMobile?: boolean;
  text?: string | ReactNode;
  onClose?: () => void;
};

export const ModalHeader = ({
  icon,
  iconBgColor = "bg-orange-200",
  hideIconOnMobile = false,
  text,
  onClose,
}: ModalHeaderProps) => (
  <div className="flex justify-between items-center gap-medium h-[6.4rem] px-[1.6rem] mobile:px-[2.4rem] py-[1.2rem]">
    {icon && (
      <div
        className={clsx(
          "rounded w-[4rem] h-[4rem] justify-center items-center",
          hideIconOnMobile ? "hidden mobile:flex" : "flex",
          iconBgColor,
        )}
      >
        <Icon
          className={
            icon === "archie" ? "w-[4rem] h-[4rem]" : "w-[2.2rem] h-[2.2rem]"
          }
          name={icon}
        />
      </div>
    )}
    {text && (
      <div className="text-paragraph mobile:text-h3 font-semibold font-poppins flex-1 [&>h4]:truncate overflow-hidden">
        {typeof text === "string" ? (
          <Displayer value={text} paragraphTag="h4" />
        ) : (
          text
        )}
      </div>
    )}
    {onClose && (
      <Button
        leftIcon="solidXmarkLarge"
        aria-label="Close Modal - X"
        variant="secondarySubtle"
        onClick={() => onClose()}
      />
    )}
  </div>
);
